import React from 'react';

// Assets
import processingFile from '@/images/design-system-v2/loading-state/processing-file.gif';

// Components
import ProgressBar from '@/views/components/common/ProgressBar';
import { FormattedMessageV2 } from '@/views/components/i18n';

type Props = {
  portfolioCount: number;
};

const ExtractStep: React.FC<Props> = ({ portfolioCount }) => {
  const i18nBasePath = 'ProcessingFile';

  return (
    <div className="extract-step">
      <img className="image" src={processingFile} alt="processing-file" />
      <FormattedMessageV2 className="title" toLocalize={`${i18nBasePath}.ExtractingPortfoliosStep.Title`} values={{ count: portfolioCount }} />
      <FormattedMessageV2 className="subtitle" toLocalize={`${i18nBasePath}.ExtractingPortfoliosStep.Body`} />
      <ProgressBar progress={100} />
      <FormattedMessageV2 className="disclosure" toLocalize={`${i18nBasePath}.Disclosure`} />
    </div>
  );
};

export default ExtractStep;
